import React from 'react';
import * as S from '../styles';
import BlackSwanLogoLink from './BlackSwanLogoLink';

const BlackSwanSection = ({ i18n }) => {
  return (
    <S.BlackSwan>
      <S.Wrap>
        <S.BlackSwanLogoWrap>
          <BlackSwanLogoLink />
        </S.BlackSwanLogoWrap>
        <h2>{i18n.mainPage.haveAdviser}</h2>
        <p>{i18n.mainPage.shareLink}</p>
        <p className="link">
          <a href="https://blackswan.finance" target="_blank" rel="noopener noreferrer">
            {i18n.mainPage.visit}
          </a>
        </p>
      </S.Wrap>
    </S.BlackSwan>
  );
};

export default BlackSwanSection;
